import { createSlice } from '@reduxjs/toolkit';


interface flowBuilderState {
    preferences:any;
    addedNodeList:any;
    insertData:any,
    envList:any
    instanceList:any;
  }
const initialState: flowBuilderState = {
    preferences:{},
    addedNodeList:[],
    insertData:[],
    envList:[],
    instanceList:[]
    
};
export const flowBuilder = createSlice({
  name: 'flowBuilder',
  initialState: initialState,
  reducers: {
    setPreferences: (state,action:any) => { 
        state.preferences=action.payload;
      },
    setAddedNodeList: (state,action:any) => { 
        state.addedNodeList=action.payload;
      },
    setInsertData: (state,action:any) => { 
        state.insertData=action.payload;
      },
    setEnvListData: (state,action:any) => { 
        state.envList=action.payload;
      },
    setInstanceListData: (state,action:any) => { 
        state.instanceList=action.payload;
      },
    }
});

// this is for dispatch
export const { setPreferences,setAddedNodeList,setInsertData,setEnvListData,setInstanceListData } = flowBuilder.actions;

// this is for configureStore
export default flowBuilder.reducer;